import { getQueryParam, updateQueryString } from '../shared/utils.js';
import { getTabIdFromLink } from './utils.js';
import { tabQueryParam, pgQueryParam } from '../../../config.js';
import { selectors, elements } from './elements.js';
import { fetchResults } from './fetchResults.js';

export const initializeTabs = () => {
    const { tabLinks } = elements;

    if (!tabLinks || !tabLinks.length) {
        return;
    }

    tabLinks.forEach(link => {
        if (link.classList.contains('js-initialised')) {
            return;
        }

        link.classList.add('js-initialised');
        link.addEventListener('click', (event) => {
            event.preventDefault();

            const targetId = getTabIdFromLink(link);
            if (!targetId) {
                return;
            }

            // Update the UI to reflect the selected tab
            showTab(targetId);
        });
    });

    // Show the initial tab based on the URL parameter or default to 'pages'
    const initialTab = getQueryParam(tabQueryParam) || 'pages';
    highlightTabLink(initialTab);
};

export const highlightTabLink = (targetId) => {
    if (!targetId) {
        return;
    }

    // Highlight the selected tab link
    const tabLinks = document.querySelectorAll(selectors.tabLinks);
    if (tabLinks && tabLinks.length) {
        tabLinks.forEach(link => {
            const tabIsSelected = getTabIdFromLink(link) === targetId;
            if (tabIsSelected) {
                link.classList.add('border-black');
                link.classList.remove('border-transparent');
            } else {
                link.classList.remove('border-black');
                link.classList.add('border-transparent');
            }
        });
    }
};

export const updateTabCounts = (counts) => {
    Object.keys(counts).forEach((section) => {
        const countElement = document.querySelector(selectors.tabLinkCountElement(section));
        if (countElement) {
            countElement.textContent = counts[section];
        }
    });
};

const showTab = (targetId) => {
    if (!targetId) {
        return;
    }

    // Update the `tab` query string parameter
    updateQueryString({ [tabQueryParam]: targetId });

    // Reset to page 1 on tab change.
    updateQueryString({ [pgQueryParam]: 1 });

    // Refetch results with the updated tab
    fetchResults(false);
};
